import {
  formatCardNumber,
  formatCvv,
  formatExpiry,
  restoreCursor,
} from "@/utils/payment/cardInputFormatters";

export const prepareCardSubmissionData = (data) => {
  const unmaskedCardNumber = data.cardNumber
    ? data.cardNumber.replace(/\D/g, "")
    : "";

  const [month = "", year = ""] = data.expiry ? data.expiry.split("/") : [];

  return {
    CCV: data.cvv,
    CardHolder: data.name,
    CardNumber: unmaskedCardNumber,
    ExpirationMonth: parseInt(month, 10),
    ExpirationYear: parseInt(year ? `20${year}` : "", 10),
  };
};

export const createCardInputHandlers = ({ onChange, errors, clearErrors }) => {
  const handleCardNumberChange = (e, field) => {
    const inputEl = e.target;
    const rawValue = inputEl.value;
    const cursorPos = inputEl.selectionStart ?? rawValue.length;
    const digitsBeforeCursor = rawValue.slice(0, cursorPos).replace(/\D/g, "").length;

    const formatted = formatCardNumber(rawValue);
    field.onChange(formatted);

    if (onChange) {
      onChange({ cardNumber: formatted });
    }
    if (errors.cardNumber) {
      clearErrors("cardNumber");
    }

    requestAnimationFrame(() =>
      restoreCursor(inputEl, formatted, digitsBeforeCursor),
    );
  };

  const handleExpiryChange = (e, field) => {
    const inputEl = e.target;
    const rawValue = inputEl.value;
    const cursorPos = inputEl.selectionStart ?? rawValue.length;
    const digitsBeforeCursor = rawValue.slice(0, cursorPos).replace(/\D/g, "").length;

    const cleaned = rawValue.replace(/\D/g, "").slice(0, 4);
    const now = new Date();
    const currentYear = now.getFullYear() % 100;
    const currentMonth = now.getMonth() + 1;

    if (cleaned.length >= 1 && parseInt(cleaned[0], 10) > 1) {
      return;
    }
    if (cleaned.length >= 2) {
      const month = parseInt(cleaned.substring(0, 2), 10);
      if (month === 0 || month > 12) {
        return;
      }
    }
    if (cleaned.length >= 3) {
      const yearFirstDigit = parseInt(cleaned[2], 10);
      const currentYearFirstDigit = Math.floor(currentYear / 10);
      if (yearFirstDigit < currentYearFirstDigit) {
        return;
      }
    }
    if (cleaned.length === 4) {
      const month = parseInt(cleaned.substring(0, 2), 10);
      const year = parseInt(cleaned.substring(2, 4), 10);
      if (year < currentYear) {
        return;
      }
      if (year === currentYear && month < currentMonth) {
        return;
      }
    }

    const formatted = formatExpiry(cleaned);
    field.onChange(formatted);

    if (onChange) {
      onChange({ expiry: formatted });
    }
    if (errors.expiry) {
      clearErrors("expiry");
    }

    requestAnimationFrame(() =>
      restoreCursor(inputEl, formatted, digitsBeforeCursor),
    );
  };

  const handleCvvChange = (e, field) => {
    const inputEl = e.target;
    const rawValue = inputEl.value;
    const cursorPos = inputEl.selectionStart ?? rawValue.length;
    const digitsBeforeCursor = rawValue.slice(0, cursorPos).replace(/\D/g, "").length;

    const formatted = formatCvv(rawValue);
    field.onChange(formatted);

    if (onChange) {
      onChange({ cvv: formatted });
    }
    if (errors.cvv) {
      clearErrors("cvv");
    }

    requestAnimationFrame(() =>
      restoreCursor(inputEl, formatted, digitsBeforeCursor),
    );
  };

  return { handleCardNumberChange, handleExpiryChange, handleCvvChange };
};
